import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { PageLoader } from '@/layouts/components/PageLoader/PageLoader';
import { isScreenAllowed, useChatStep } from '@/features/chat';
import { routes } from '../routes';

// A screen opens only while its step is the current one, so the chat is the
// single place deciding what comes next. The guards below it (KycGuard,
// OfferGuard…) still route inside the step's own screens.
export const ChatStepGuard = () => {
  const location = useLocation();
  const { step, isLoading } = useChatStep();

  if (isLoading) {
    return <PageLoader />;
  }

  if (!step || !isScreenAllowed(step, location.pathname)) {
    return <Navigate to={routes.wizard.base} replace />;
  }

  return <Outlet />;
};
